import mList from '_v/common/m-list'
import rechargeweflowAdvSearch from '_v/recharge/rechargeweflow-adv-search'
import SelectTags from '_vc/select-tags'


export default {
    mixins: [mList],
    components: {
        rechargeweflowAdvSearch,
        SelectTags,
    },
    data() {
        return {
            userNameMap: {},
            support: {
                multiRooms: true,
            },
        }
    },
    computed: {
        
    },
    methods: {
        // 关闭搜索条件
        onAdvItemClose(item, index) {
            var key = item.key

            // daterange
            if (key.indexOf('-') >= 0) {
                var [k1, k2] = key.split('-')

                this.advFilter[k1] = ''
                this.advFilter[k2] = ''
            }
            // select
            else if (typeof this.advFilter[key] === 'object') {
                this.advFilter[key].splice(index, 1)
            }
            // others
            else {
                this.advFilter[key] = ''
            }

            this.$nextTick(() => this.search())
        },
        // 高级搜索
        onAdvConfirm(val, options) {
            this.advOptions = options
            this.$nextTick(() => this.search())
        },
        normalizeAdvFilter(advFilter) {
            var filter = Object.assign({}, advFilter)

            Object.keys(filter).forEach((k) => {
                switch (k) {                    
                    case 'weflowAmountZfType':
                    case 'tradeType':
                        if (filter[k].length) {
                            filter[k] = filter[k].join(',')
                        } else {
                            delete filter[k]
                        }

                        break
                    
                }
            })

            return filter
        },
        
    },
}
